import { Container } from "./styles";
import transline from "../../assets/transline.svg";
import ignipc from "../../assets/ignipc.svg";
import nachiketa from "../../assets/nachiketa.svg";
import Cb from "../../assets/CB.svg";
// import DownloadApp from '../../assets/download.png'
import externalLink from "../../assets/external-link.svg";
import ScrollAnimation from "react-animate-on-scroll";

export function Experiences() {
  return (
    <Container id="Experience">
      <h2>Experience and Certifications</h2>
      <div className="projects">
        <ScrollAnimation animateIn="flipInX">
          <div className="project">
            <header>
              <div className="project-links">
                <a
                  href="https://www.mynachiketa.com/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img src={nachiketa} alt="Visit site" />
                </a>
              </div>
              <div className="project-links">
                <a
                  href="https://www.mynachiketa.com/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img src={externalLink} alt="Visit site" />
                </a>
              </div>
            </header>
            <div className="body">
              <h3>My Nachiketa Foundation</h3>
              <h4>Full Stack Engineer</h4>
              <br></br>
              <p>
                I have joined Nachiketa, a sister company of Change Engine, as a
                Full Stack Engineer. In this role, I manage the company's
                website to ensure seamless performance and functionality, while
                implementing SEO strategies to enhance site traffic and online
                visibility. Additionally, I am actively working on various
                projects, leveraging my technical expertise to deliver impactful
                solutions.
              </p>
            </div>
            <footer>
              {" "}
              <ul className="tech-list">
                {" "}
                <li>Jan 2025 - Present, Delhi</li>
              </ul>{" "}
            </footer>
          </div>
        </ScrollAnimation>

        <ScrollAnimation animateIn="flipInX">
          <div className="project">
            <header>
              <div className="project-links">
                <a href="https://ignipc.com/" target="_blank" rel="noreferrer">
                  <img src={ignipc} alt="Visit site" />
                </a>
              </div>
              <div className="project-links">
                <a href="https://ignipc.com/" target="_blank" rel="noreferrer">
                  <img src={externalLink} alt="Visit site" />
                </a>
              </div>
            </header>
            <div className="body">
              <h3>IgniPC Private Limited</h3>
              <h4>Full Stack Engineer Intern</h4>
              <br></br>
              <p>
                Developed software at igniPC using Next.js, React.js,
                PostgreSQL, Amazon Cognito, and AWS, while managing their
                products. Built the B2B website, contributed to B2C pages, and
                created dynamic, reusable components in Next.js. Gained strong
                expertise in Next.js, database design, and management, along
                with experience in Next SEO, web scraping, and Git version
                control.
              </p>
            </div>
            <footer>
              {" "}
              <ul className="tech-list">
                {" "}
                <li>Aug 2024 - Oct 2024, Delhi</li>
              </ul>{" "}
            </footer>
          </div>
        </ScrollAnimation>

        <ScrollAnimation animateIn="flipInX">
          <div className="project">
            <header>
              <div className="project-links">
                <a
                  href="https://www.translineindia.com/"
                  target="\_blank"
                  rel="noreferrer"
                >
                  <img src={transline} alt="Visit site" />
                </a>
              </div>
              <div className="project-links">
                <a
                  href="https://www.translineindia.com/"
                  target="\_blank"
                  rel="noreferrer"
                >
                  <img src={externalLink} alt="Visit site" />
                </a>
              </div>
            </header>
            <div className="body">
              <h3>Transline Technologies Limited</h3>
              <h4>Software Developer and AI/ML Intern</h4>
              <br></br>
              <p>
                During my internship as a Software Developer and AIML Intern, I
                developed detection models, worked on image processing, and
                created solutions like ANPR, Vehicle Detection etc. I gained
                experience in data collection, model training, and applying
                machine learning to real-world problems.
              </p>
            </div>
            <footer>
              {" "}
              <ul className="tech-list">
                {" "}
                <li>Feb 2024 - July 2024, Delhi</li>
              </ul>{" "}
            </footer>
          </div>
        </ScrollAnimation>
        <ScrollAnimation animateIn="flipInX">
          <div className="project">
            <header>
              <div className="project-links">
                <a
                  href="https://codingblocks.com/"
                  target="\_blank"
                  rel="noreferrer"
                >
                  <img src={Cb} alt="Visit site" />
                </a>
              </div>
              <div className="project-links">
                <a
                  href="https://codingblocks.com/"
                  target="\_blank"
                  rel="noreferrer"
                >
                  <img src={externalLink} alt="Visit site" />
                </a>
              </div>
            </header>
            <div className="body">
              <h3>Coding Blocks</h3>
              <h4>Web Development Trainee</h4>
              <br></br>
              <p>
                Proficient in MERN (MongoDB, Express.js, Node.js, React.js)
                stack with practical project experience. Facilitated
                collaborative learning by engaging peers and addressing queries.
                Partnered with mentors on industry projects, deploying web
                applications with MERN stack technologies.
              </p>
            </div>
            <footer>
              {" "}
              <ul className="tech-list">
                {" "}
                <li>Aug 2023 - Sept 2023, Noida</li>
              </ul>{" "}
            </footer>
          </div>
        </ScrollAnimation>

        <ScrollAnimation animateIn="flipInX">
          <div className="project">
            <header>
              <div className="project-links">
                <a
                  href="https://codingblocks.com/"
                  target="\_blank"
                  rel="noreferrer"
                >
                  <img src={Cb} alt="Visit site" />
                </a>
              </div>
              <div className="project-links">
                <a
                  href="https://codingblocks.com/"
                  target="\_blank"
                  rel="noreferrer"
                >
                  <img src={externalLink} alt="Visit site" />
                </a>
              </div>
            </header>
            <div className="body">
              <h3>Full Stack Web Development (MERN)</h3>
              <a
                href="https://www.linkedin.com/in/sabeelhps/"
                target="\_blank"
                rel="noreferrer"
              >
                <h4 className="Mentor">By Sabeel Khan</h4>
              </a>

              <br></br>
              <p>
                I have completed a comprehensive course in Full Stack Web
                Development, where I gained hands-on experience with a variety
                of development skills and technologies, including HTML, CSS,
                JavaScript, Express.js, React, Node.js, MongoDB, jQuery, and
                version control systems like Git. During the course, I worked on
                multiple projects, applying these skills to build dynamic and
                responsive web applications
              </p>
            </div>
            <footer>
              {" "}
              <ul className="tech-list">
                {" "}
                <li>Jan 2023 - July 2023, Noida</li>
              </ul>{" "}
            </footer>
          </div>
        </ScrollAnimation>

        <ScrollAnimation animateIn="flipInX">
          <div className="project">
            <header>
              <div className="project-links">
                <a
                  href="https://codingblocks.com/"
                  target="\_blank"
                  rel="noreferrer"
                >
                  <img src={Cb} alt="Visit site" />
                </a>
              </div>
              <div className="project-links">
                <a
                  href="https://codingblocks.com/"
                  target="\_blank"
                  rel="noreferrer"
                >
                  <img src={externalLink} alt="Visit site" />
                </a>
              </div>
            </header>
            <div className="body">
              <h3>C++ Programming and DSA</h3>
              <a
                href="https://www.linkedin.com/in/mosinaashraf/"
                target="\_blank"
                rel="noreferrer"
              >
                <h4 className="Mentor">By Mosina Ashraf</h4>
              </a>

              <br></br>
              <p>
                Completed a course in C++ Programming and Data Structures and
                Algorithms (DSA), where I mastered the fundamentals of C++ and
                gained in-depth knowledge of key data structures such as arrays,
                linked lists, stacks, queues, trees, and heaps. I also learned
                and implemented various sorting and searching algorithms,
                enhancing my problem-solving and computational thinking skills.
              </p>
            </div>
            <footer>
              {" "}
              <ul className="tech-list">
                {" "}
                <li>May 2022 - Nov 2022, Noida</li>
              </ul>{" "}
            </footer>
          </div>
        </ScrollAnimation>
      </div>
    </Container>
  );
}
